export const isPremiumCustomer = () =>
  process.env.REACT_APP_CLIENT_TYPE === "PREMIUM";

export const routePath = (merchantCode: string, path: string) =>
  isPremiumCustomer() ? path : path.replace(`/`, `/${merchantCode}/`);
